module.exports = __webpack_public_path__ + "static/img/10y.079ed59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10y.jpg
// module id = ExE9
// module chunks = 0